'use strict';

var $ = require('jquery');

function init() {
	if (!document.querySelector('.page--email-signature')) return;


	var PRI = PRI || {};

	PRI.signature = (function($){

		var selectText = function(element) {
			var doc = document;

			if (doc.body.createTextRange) { // ms
				var range = doc.body.createTextRange();
				range.moveToElementText(element);
				range.select();
			} else if (window.getSelection) { // moz, opera, webkit
				var selection = window.getSelection();
				var range = doc.createRange();
				range.selectNodeContents(element);
				selection.removeAllRanges();
				selection.addRange(range);
			}
		}

		var baseHref = $('base').attr('href');

		/**
		 * Factory for phone number output
		 * @param {object[]} phones The person's phone numbers
		 * @param {object} styles Form styling
		 * @return {string}
		 */
		function buildPhone(phones, styles) {
			var output = [];

			for (var i = 0; i < phones.length; i++) {
				if (phones[i].value) {
					output.push(
						'<tr>'
						+'<td colspan="2" style="padding-top: 3px; padding-bottom: 0;">'
						+'<span style="'+styles.b+'">' + phones[i].initial.toUpperCase() + ' </span>'
						+'<span style="white-space: nowrap;"><a href="tel: '+ phones[i].value +'" style="'+styles.a+'">'+ phones[i].value +'</a></span>'
						+'</td>'
						+'</tr>'
					);
				}
			}
			return output.join('');
		}

		var generateSig = function( person, company ){
			var colorBlue = '#50596c';
			var styles = {
				a: 'color: '+colorBlue+'; font-weight:normal; text-decoration: none;',
				b: 'color: '+colorBlue+'; font-weight:bold;'
			};

			var name = person.name || 'YOUR NAME HERE';
			var title = person.title || '';
			var number = buildPhone(person.phones, styles);
			var email = person.email || company.email;

			var html = '<table border="0" cellspacing="0" cellpadding="0" bgcolor="white">'
			+'	<tr>'
			+'		<td width="360">'
			+'			<table border="0" cellspacing="0" cellpadding="0" style="font-family: Georgia, serif; font-size: 12px;">'
			+'				<tr><td colspan="2" style="padding-bottom: 20px;"><span style="font-size: 16px; font-family: georgia, times, serif;color: '+colorBlue+'">' + 'Regards,' + '</span></td></tr>'
			+'				<tr><td colspan="2" valign="bottom"><span style="font-size: 18px; font-weight: bold; font-family: georgia, times, serif;color: '+colorBlue+'">' + name.toUpperCase() + '</span></td></tr>'
			+'				<tr><td colspan="2" valign="bottom" style="padding-bottom: 20px;padding-top:0;"><span style="font-size: 13px; font-family: georgia, times, serif;color: '+colorBlue+'">' + title.toUpperCase() + '</span></td></tr>'
			+				number
			+'				<tr>'
			+'					<td colspan="2" style="padding-top: 3px">'
			+'<span style="'+styles.b+'">E </span><span style="white-space: nowrap;"><a href="mailto: '+ email +'" style="'+styles.a+'">'+ email +'</a><span></span>'
			+'					</td>'
			+'				</tr>'
			+'				<tr>'
			+'					<td colspan="2" style="padding-top: 10px">'
			+'					  <img src="' + baseHref + '/assets/images/email/blue-bar.gif" height="2" width="96" style="display: block;" />'
			+'					</td>'
			+'				</tr>'
			+'				<tr>'
			+'					<td colspan="2" style="padding-top: 20px; padding-bottom: 10px">'
			+'						<a href="'+company.website.url+'" style="'+styles.a+'">'
			+'							<img src="' + baseHref + '/assets/images/email/' + company.logo + '" width="' + company.logoWidth + '" height="' + company.logoHeight + '" style="display: block;" alt="'+ company.logoAlt +'" />'
			+'						</a>'
			+'					</td>'
			+'				</tr>'
			+'				<tr>'
			+'					<td style="padding-top: 3px">'
			+'						<span style="font-size: 9px;' + styles.a + '">294 Grove Lane East, Suite 120<br />Wayzata, MN 55391</span>'
			+'					</td>'
			+'					<td style="padding-top: 3px" valign="top">'
			+'						<a href="tel:8665676282" style="font-size: 9px;'+ styles.a + '">(866) 567-6282</a>'
			+'					</td>'
			+'				</tr>'
			+'				<tr>'
			+'					<td style="padding-top: 3px">'
			+'						<span style="font-size: 9px;' + styles.a + '">232 Manhattan Beach Blvd, Suite D<br/>Manhattan Beach, CA 90266</span>'
			+'					</td>'
			+'					<td style="padding-top: 3px" valign="top">'
			+'						<a href="tel:8003574604" style="font-size: 9px;'+ styles.a + '">(800) 357-4604</a>'
			+'					</td>'
			+'				</tr>'
			+'				<tr>'
			+'					<td style="padding-top: 10px" colspan="2">'
			+'						<span style="font-size: 9px;' + styles.a + '"><em>Investment banking services offered through SkyView Investment Banking member <a href="https://www.sipc.org/" target="_blank">SIPC</a> and <a href="https://www.finra.org/#/" target="_blank">FINRA</a>. SkyView Investment Banking is a wholly owned subsidiary of SkyView Legacy Partners, LLC.</em></span>'
			+'					</td>'
			+'				</tr>'
			+'			</table>'
			+'		</td>'
			+'	</tr>'
			+'</table>';
			return html;
		};

		var sigForm;
		var sigArea;
		var pub = {
			setup: function() {
				sigForm = $('#generateSigForm');
				sigArea = $("#signature");

				function changeit(){
					var person = {
						name: sigForm.find("[name='name']").val(),
						title: sigForm.find('[name="title"]').val(),
						phones: [
							{initial: 'p', value: sigForm.find("[name='phone']").val()},
							{initial: 'm', value: sigForm.find("[name='mobile']").val()},
							{initial: 'c', value: sigForm.find("[name='cell']").val()},
							{initial: 'o', value: sigForm.find("[name='office']").val()}
						],
						email: sigForm.find('[name="email"]').val()
					}

					var companyName = sigForm.find('[name="company"]').val();
					var company = {
						name: companyName == 'skyview1' ? 'SkyView1' : 'SkyView Partners',
						logo: companyName == 'skyview1' ? 'email-signature-skyview1.jpg' : 'email-signature.png',
						logoAlt: companyName == 'skyview1' ? 'SkyView1' : 'SkyView Partners - Funding Financial Advisor Growth',
						logoWidth: companyName == 'skyview1' ? 283 : 360,
						logoHeight: 51,
						tel: '763-452-4550',
						email: 'info@skyview.com',
						website: {
							url: 'https://www.skyview.com/',
							text: 'www.skyview.com'
						}
					};

					// NOTE: Uncomment for quick testing of layout/appearance
					// person =
					// 	name: 'Scott Wetzel, JD AIF',
					// 	title: 'Managing Partner',
					// 	direct: '(612) 760-4444',
					// 	email: 'Scott.Wetzel@skyview.com'
					// }

					sigArea.html(generateSig( person, company ));
					return false; // Stop form from submitting.
				}
				sigForm.on('change', changeit);
				sigForm.on('submit', changeit);

				$('#selectSignature').click(function(){
					selectText( sigArea.get(0) );
				});
			}
		};

		return pub;

	})($);


	$(function(){
		PRI.signature.setup();
	});

}

module.exports = {
	init: init
};
